/**
 * 전체화면 활성
 *
 * @returns {Promise<boolean>} 성공 여부
 */
export const enableFullScreen = async (): Promise<boolean> => {
    try {
        if (!document.fullscreenElement) {
            await document.documentElement.requestFullscreen();
        }
        return true;
    } catch (error) {
        console.error('전체화면 오류: ', error);
        return false;
    }
};

/**
 * 전체화면 해제
 *
 * @returns {Promise<boolean>} 성공 여부
 */
export const disableFullScreen = async (): Promise<boolean> => {
    try {
        if (document.fullscreenElement) {
            await document.exitFullscreen();
        }
        return true;
    } catch (error) {
        console.error('전체화면 해제 오류: ', error);
        return false;
    }
};

/**
 * 뒤로가기
 */
export const historyBack = () => {
    window.history.back();
};

/**
 * 공통 버튼 색상
 *
 * @param value
 */
export const getTypeColor = (value: number) => {
    const colors = {
        1: 'success',
        0: 'dark',
        [-1]: 'warning',
        [-2]: 'danger',
        [-3]: 'outline',
    };
    return colors[value] || 'default';
};